import { MutationTree } from 'vuex'
import { AuthState } from './state'
import { UserProfile } from '../../types'

const mutations: MutationTree<AuthState> = {
  IS_AUTHENTICATED_UPDATED: (state, isAuthenticated: boolean) => {
    state.isAuthenticated = isAuthenticated
  },

  PROFILE_UPDATED: (state, userProfile: UserProfile) => {
    state.userProfile = userProfile
  },

  IS_ADMIN_UPDATED: (state, isAdmin: boolean) => {
    state.isAdmin = isAdmin
  },

  IS_CONTENT_CREATOR_UPDATED: (state, isContentCreator: boolean) => {
    state.isContentCreator = isContentCreator
  },

  IS_TWO_FACTOR_REQUIRED_UPDATED: (state, isTwoFactorRequired: boolean) => {
    state.isTwoFactorRequired = isTwoFactorRequired
  },

  IS_AUTH_LOADING_UPDATED: (state, isAuthLoading: boolean) => {
    state.isAuthLoading = isAuthLoading
  },

  REDIRECT_URL_UPDATED: (state, redirectUrl: string) => {
    state.redirectUrl = redirectUrl
  },

  SAMPLE_AVATARS_UPDATED: (state, sampleAvatars: Array<object>) => {
    state.sampleAvatars = sampleAvatars
  },

  AVATAR_UPDATED: (state, avatar: string) => {
    state.currentAvatar = avatar
  },

  PHONE_NUMBER_UPDATED: (state, preferred_phone_number: string) => {
    state.userProfile = {
      ...state.userProfile,
      preferred_phone_number,
    }
  },

  MFA_METHOD_UPDATED: (state, method: string | null = null) => {
    state.userProfile = { ...state.userProfile, mfa_method: method }
  },

  SUBSCRIPTION_STATUS_UPDATED: (state, status: string) => {
    state.subscriptionStatus = status
  },

  PROFILE_PREFERENCES_UPDATED: (state, preferences: object) => {
    state.profilePreferences = preferences
  },

  SECURITY_AWARENESS_ENROLLMENT_STATUS_UPDATED: (state, isEnrolled) => {
    state.isEnrolledInSecurityAwareness = isEnrolled
  },
}

export default mutations
